module.exports = __webpack_public_path__ + "img/flexsale-refined-1.2cefa799.png";